import { matchPath } from "react-router-dom";

// Check if path is an external link
export const isExternalLink = (path: string | undefined | null) => {
    if (!path) return false;
    return path.startsWith("http://") || path.startsWith("https://");
};

// Normalize path by removing trailing slashes (except for root)
export const normalizePath = (pathname: string) => {
    if (pathname === "/") return "/";
    return pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
};

type CheckIsActiveParams = {
    pathname: string;
    currentPathname: string;
    allowNested?: boolean;
    isActive?: (pathname: string, currentPathname: string) => boolean;
};

export const checkIsActive = ({ pathname, currentPathname, allowNested = true, isActive }: CheckIsActiveParams) => {
    if (isActive) {
        return isActive(pathname, currentPathname);
    }

    const normalizedPathname = normalizePath(pathname);
    const normalizedCurrentPath = normalizePath(currentPathname);

    if (normalizedCurrentPath === normalizedPathname) {
        return true;
    }

    if (allowNested && normalizedPathname !== "" && normalizedPathname !== "/") {
        const match = matchPath({ path: pathname, end: false }, currentPathname);
        if (match) return true;
        return normalizedCurrentPath.startsWith(normalizedPathname + "/");
    }

    return false;
};
